import RichTextTemplateModal from './RichTextTemplateModal';

export default RichTextTemplateModal;
